import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AuthGuard } from "./core/auth/auth.guard";
import { SecureInnerPagesGuard } from "./core/auth/SecureInnerPages.guard";
import { SidebarComponent } from "./components/shared/sidebar/sidebar.component";
import { AppCustomPreloader } from "./core/helpers/preloadStrategy";
import {
  USER_DETAIL,
  USERS,
  PLANTS,
  PLANT_DETAIL,
  NOT_FOUND,
} from "./core/constants/route_paths";

const routes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./components/pages/login/login.module").then((m) => m.LoginModule),
    canActivate: [SecureInnerPagesGuard],
  },
  {
    path: "",
    component: SidebarComponent,
    children: [
      {
        path: USER_DETAIL,
        loadChildren: () =>
          import("./components/pages/user/user-detail/user-detail.module").then(
            (m) => m.AddUserModule
          ),
        canActivate: [AuthGuard],
        data: {
          title: "label.userDetail",
        },
      },
      {
        path: USERS,
        loadChildren: () =>
          import("./components/pages/user/user-list/user-list.module").then(
            (m) => m.UsersListModule
          ),
        canActivate: [AuthGuard],
        data: {
          title: "menu.users",
        },
      },
      {
        path: PLANTS,
        loadChildren: () =>
          import("./components/pages/plant/plant-list/plant-list.module").then(
            (m) => m.PlantsModule
          ),
        canActivate: [AuthGuard],
        data: {
          title: "menu.warehouses",
        },
      },
      {
        path: PLANT_DETAIL,
        loadChildren: () =>
          import("./components/pages/plant/plant-detail/plant-detail.module").then(
            (m) => m.AddPlantModule
          ),
        canActivate: [AuthGuard],
        data: {
          title: "label.detail",
        },
      },
      {
        path: NOT_FOUND,
        loadChildren: () =>
          import("./components/pages/404/404.module").then(
            (m) => m.NotFoundErrorModule
          ),
        data: { preload: true },
      },
    ],
  },
  {
    path: "**",
    redirectTo: NOT_FOUND,
  },
  {
    path: "",
    pathMatch: "full",
    redirectTo: USERS,
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: AppCustomPreloader }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
